import {UA_SUCCESS} from '../get-audits/constants'
import {updateAudit as updateAuditAPI} from '../../../services/audits'

export async function updateAudit(id, data = null, dispatch) {
  try {
    let response = await updateAuditAPI(id, data)
    dispatch({type: UA_SUCCESS, payload: response})
    return response
  } catch (e) {
    console.log(`Update Audit Failed: ${data.name}`)
    return e.response
  }
}
